var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "analyses-hero rounded-lg",
      attrs: { "data-qa": "analyses_hero_section" },
    },
    [
      _c(
        "div",
        {
          class: [
            "d-flex flex-nowrap flex-column align-center justify-space-between ga-6 py-8 px-6 position-relative",
            "flex-sm-row align-sm-stretch ga-sm-4 pa-sm-8 pl-sm-8 pr-sm-0",
          ],
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column flex-grow-1 gr-6 gr-sm-4 min-w-0",
            },
            [
              _c("div", { staticClass: "d-flex flex-column gr-6" }, [
                _c(
                  "h1",
                  {
                    staticClass: "text--text mb-0",
                    class: _setup.isMobile ? "text-h6" : "text-stat-item",
                    attrs: { "data-qa": "analyses_hero_title" },
                  },
                  [
                    _vm._v(
                      "\n          Анализы в " +
                        _vm._s(_vm.townNamePred) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "text-body-1 text-secondary--text mb-0",
                    attrs: { "data-qa": "analyses_hero_subtitle" },
                  },
                  [
                    _vm._v(
                      "\n          Найдите, где сдать анализы, сравните цены в клиниках и лабораториях"
                    ),
                    _setup.context.is_analyses_appointment_available_in_town
                      ? [_vm._v(", оплатите онлайн со скидкой")]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _setup.context.feature_flags.ff_analyses_search
                ? _c(_setup.AnalysesHeroSearch)
                : _vm._e(),
              _vm._v(" "),
              _vm.popularAnalyses.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "analyses-hero__popular d-flex flex-column flex-sm-row flex-sm-nowrap ga-2 min-w-0",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-body-2 text-secondary--text flex-shrink-0",
                        },
                        [_vm._v("\n          Популярные анализы\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "analyses-hero__popular-tags d-flex flex-nowrap flex-sm-wrap ga-2 min-w-0",
                        },
                        _vm._l(_vm.popularAnalyses, function (analysis) {
                          return _c(
                            "a",
                            {
                              key: analysis.name,
                              staticClass:
                                "analyses-hero__tag d-inline-flex align-center rounded-pill px-3 py-1 text-body-2 primary--text text-decoration-none flex-shrink-0",
                              attrs: {
                                href: analysis.href,
                                "data-qa": "analyses_hero_popular_tag",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(analysis.name) +
                                  "\n          "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("img", {
            staticClass: "analyses-hero__illustration flex-shrink-0",
            attrs: {
              src: `${_setup.staticPath}_v1/pd/pictures/analyzes/hero-microscope.png`,
              alt: "",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }